import { useEffect, useState, useCallback } from "react";
import { getSprintsOptions } from "@/api/sprints";

export const useUnitSprints = (unitUuid, initialSprint = null) => {
  const [sprintsOptions, setSprintsOptions] = useState(
    initialSprint
      ? [{ ...initialSprint, label: initialSprint.name }]
      : []
  );
  const [isLoading, setIsLoading] = useState(false);

  const fetchSprints = useCallback(async () => {
    if (!unitUuid) {
      setSprintsOptions([]);
      return;
    }

    setIsLoading(true);

    try {
      const sprints = await getSprintsOptions({ unit_uuid: unitUuid, units_uuids: [unitUuid] });
      setSprintsOptions(sprints?.map((s) => ({ ...s, label: s.name, })) || []);
    } catch (e) {
      console.error(e);
      setSprintsOptions([]);
    } finally {
      setIsLoading(false);
    }
  }, [unitUuid]);

  useEffect(() => {
    fetchSprints();
  }, [fetchSprints]);

  return {
    sprintsOptions,
    isLoadingSprints: isLoading,
    reloadSprints: fetchSprints,
  };
};
